import { render, staticRenderFns } from "./TripleTableTwoColumns.vue?vue&type=template&id=0b028ee6"
import script from "./TripleTableTwoColumns.vue?vue&type=script&lang=js"
export * from "./TripleTableTwoColumns.vue?vue&type=script&lang=js"
import style0 from "./TripleTableTwoColumns.vue?vue&type=style&index=0&id=0b028ee6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports